export const existsGtoStore = () => (dispatch, getState) => {
  const storageList = getState();
  const exists = !!storageList.gto.gtosList.length;

  return exists;
};

export const fetchGtos = payload => ({
  type: 'gto/FETCH_DATA',
  payload
});

export const fetchAllGtos_ME = codigoPrestador => dispatch => {
  dispatch({ type: 'gto/LOADING' });
  //return fetchGtoBackaground_ME(codigoPrestador)
  //.then(res => {
  //const gtosList = res.data.data.glosadas;
  const gtosList = [
    {
      beneficiary: {
        codBenef: 123,
        contrato: 123,
        nomeBenef: 'João da Silva',
        flagElegivel: true,
        dataVenc: '01/01/2020',
        dataAtualizacao: null
      },
      gtoId: 11301130,
      idOdonto: 25610,
      inclusionDate: '01/01/2020',
      updateDate: null,
      procedures: [
        {
          procedureId: 1234,
          planId: 35,
          gtoId: 11301130,
          idtProcGto: 4331123,
          isoProcedure: {
            codigo: 8410002,
            descricao: 'APLICAÇÃO TÓPICA DE FLÚOR',
            flagFaceObrig: false,
            flagDenteObrig: false,
            flagRegiaoObrig: true,
            flagImagemObrig: false,
            flagImgProcedimento: false,
            facesPermit: [],
            dentesPermit: [],
            listaRegiao: [],
            flagDentePerm: false,
            flagDenteDec: false,
            flgDivulga: true,
            qtdeFaces: 1,
            qtdeMaxFaces: 1
          },
          status: 'GLOSADO',
          face: '',
          region: 'ASAI',
          tooth: '',
          executeDate: '01/01/2020',
          images: [],
          justify: 'Justify',
          reason: 'Reason',
          warning: 'warning',
          flagImgProcedimento: false,
          row: 1,
          dataPagamento: '01/01/2020',
          excluido: false,
          flagNecessitaLaudo: false,
          flagRxInicial: false,
          flagRxfinal: false
        },
        {
          procedureId: 1235,
          planId: 35,
          gtoId: 11301130,
          idtProcGto: 4331124,
          isoProcedure: {
            codigo: 85200018,
            descricao: 'CLAREAMENTO DE DENTE DESVITALIZADO',
            flagFaceObrig: false,
            flagDenteObrig: false,
            flagRegiaoObrig: true,
            flagImagemObrig: false,
            flagImgProcedimento: false,
            facesPermit: [],
            dentesPermit: [],
            listaRegiao: [],
            flagDentePerm: false,
            flagDenteDec: false,
            flgDivulga: true,
            qtdeFaces: 1,
            qtdeMaxFaces: 1
          },
          status: 'GLOSADO',
          face: '',
          region: 'ASAI',
          tooth: '',
          executeDate: '01/01/2020',
          images: [],
          justify: 'Justify',
          reason: 'Reason',
          warning: 'warning',
          flagImgProcedimento: false,
          row: 1,
          dataPagamento: '01/01/2020',
          excluido: false,
          flagNecessitaLaudo: false,
          flagRxInicial: false,
          flagRxfinal: false
        }
      ],
      observation: 'Observação do procedimento',
      status: 'GLOSADA'
    }
  ];

  dispatch(fetchGtos({ gtosList }));

  dispatch({ type: 'gto/UNLOADING' });

  return Promise.resolve();
  //})
  //.catch(err => Promise.reject(err))
  //.finally(() => dispatch({ type: 'gto/UNLOADING' }));
};
